import { Directive, ElementRef, Host, HostListener, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { DataService } from '../_services/data.service';
@Directive({
    selector: '[appContentScroller]'
})
export class AppScrollerDirective implements OnInit {
    @Output() isNavFixed: EventEmitter<boolean> = new EventEmitter();
    @Input() navIsFixedInput: boolean;
    @Input() isBackToTop: boolean;
    @Input('appContentScroller') hostPage: string;

    constructor(el: ElementRef, private _dataService: DataService) { }

    ngOnInit() {
        // console.log('Scroll Directive intialized');
    }

    @HostListener('window:scroll', ['$event'])
    onScroll(event: any) {
        if (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop > 100) {
            this.isNavFixed.emit(true);
        } else if (this.navIsFixedInput && window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop < 10) {
            this.isNavFixed.emit(false);
        }

        if (!(this._dataService.scrollMemory[this.hostPage].curr.y - window.pageYOffset > 200
            && window.pageYOffset == 0
            && !this.isBackToTop)
        ) {
            setTimeout(() => {
                this._dataService.scrollMemory[this.hostPage].curr = { x: window.pageXOffset, y: window.pageYOffset };
            }, 0);
        }
        // console.log('Scroll:' + JSON.stringify({ x: window.pageXOffset, y: window.pageYOffset }));
    }
}









/** Older directive for ref */
// import { Directive, HostListener, ElementRef } from '@angular/core';
// @Directive({
//     selector: '[appCustomScroll]',
//     exportAs: 'appCustomScroll'
// })
// export class CustomScrollDirective {

//     disableBtn: boolean = true;
//     top: number;
//     offSetHeight: number;
//     scrollHeight: number;

//     constructor(private eleRef: ElementRef) {
//     }

//     @HostListener('scroll') onScrollEvent(event: Event) {
//         // debugger;
//         this.top = this.eleRef.nativeElement.scrollTop;
//         this.offSetHeight = this.eleRef.nativeElement.offsetHeight;
//         this.scrollHeight = this.eleRef.nativeElement.scrollHeight;
//         if (this.top === 0) {
//             this.disableBtn = true;
//         }
//         if (this.top > this.scrollHeight - this.offSetHeight - 1) {
//             this.disableBtn = false;
//         }
//     }
// }



// WEBPACK FOOTER //
// ./public/app/_directives/scroller.directive.ts